import { useMemo } from 'react';
import { renderMarkdown } from '../lib/markdown.ts';

/** Renders admin-authored Markdown (sanitized). */
export function Markdown({ source, className = '' }: { source: string; className?: string }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return <div className={`prose ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
